export default "__VITE_ASSET__DXPh_7ct__"